module.exports = __webpack_public_path__ + "static/media/03_720.a0e7d67b.jpeg";